import { Pharmacy } from '../core/pharmacy.service';

export enum VehicleIcons {
  PASSENGER = 'osobowy',
  PHARMACY = 'apteka',
}

export enum VehicleMapIcons {
  BUDYNEK_PRZEMYSLOWY = 'budynek przemysłowy',
  NADAJNIK_MOBILNY = 'nadajnik mobilny',
}

export enum VehicleTypes {
  ALL,
  CAR,
  TRUCK,
  SUPPLIER_CAR,
  OTHER,
}

export interface UserPharmacyOption {
  label: string;
  value: Pharmacy;
}

export interface UserVehicleGroupOption {
  label: string;
  value: UserVehicleGroup;
}

export class UserVehicleGroup {
  id: number;
  name: string;
  vehiclesIds: string[];
  pharmaciesIds: string[];
  constructor(userVehicleGroup: UserVehicleGroup) {
    this.id = userVehicleGroup.id;
    this.name = userVehicleGroup.name;
    this.vehiclesIds = userVehicleGroup.vehiclesIds
      ? userVehicleGroup.vehiclesIds
      : [];
    this.pharmaciesIds = userVehicleGroup.pharmaciesIds
      ? userVehicleGroup.pharmaciesIds
      : [];
  }
}
